(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-zoom-slideshow-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('cinematic-zoom-hero')) {
  customElements.define('cinematic-zoom-hero', class extends HTMLElement {
    connectedCallback() {
      // A registered custom element can connect before the HTML parser adds its children.
      if (this.controller || this.startupObserver) return;
      this.startupObserver = new MutationObserver(() => this.initialize());
      this.startupObserver.observe(this, { childList: true, subtree: true });
      this.initialize();
    }
    initialize() {
      if (this.controller || !this.isConnected || !this.querySelector('[data-cz-ready]')) return;
      this.startupObserver?.disconnect();
      this.startupObserver = null;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.images = this.slides.map(slide => slide.querySelector('img'));
      if (!this.slides.length) return;
      this.zoomMs = Math.max(100, Number(this.dataset.zoomMs) || 2500);
      this.fadeMs = Math.max(0, Number(this.dataset.fadeMs) || 0);
      this.scale = Math.max(1, Number(this.dataset.zoomScale) || 1);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.respectMotion = this.dataset.respectMotion === 'true';
      this.userPaused = this.dataset.autoplay !== 'true' || (this.respectMotion && this.motion.matches);
      this.offscreen = false;
      this.editorPaused = false;
      this.editorSelected = false;
      this.motionOverride = false;
      this.index = 0;
      this.nextIndex = null;
      this.elapsed = 0;
      this.direction = 1;
      this.phase = 'zoom';
      this.lastTime = null;
      this.frame = null;
      this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
      const pagination = this.querySelector('.cz-pagination');
      if (pagination) pagination.hidden = false;
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.show(index);
          this.sync();
        }, { signal });
      });
      // Keep keyboard users on their selected slide while a control has focus.
      this.addEventListener('focusin', () => this.sync(), { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => {
        if (this.isConnected && !signal.aborted) this.sync();
      }), { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      this.motion.addEventListener('change', () => {
        if (this.respectMotion) {
          this.motionOverride = false;
          if (this.motion.matches) this.userPaused = true;
          this.show(this.index);
        }
        this.sync();
      }, { signal });
      // Keep the selected block visible; optionally preview its zoom without advancing slides.
      document.addEventListener('shopify:block:select', event => {
        const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (selected < 0) return;
        this.editorSelected = true;
        this.editorPaused = this.dataset.editorPreview !== 'true';
        this.show(selected);
        this.sync();
      }, { signal });
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
        this.editorPaused = false;
        this.editorSelected = false;
        this.show(this.index);
        this.sync();
      }, { signal });
      // Restart timing when an image is ready; a slow download never uses up its zoom time.
      this.images.forEach(image => {
        if (!image) return;
        const refresh = () => {
          const active = this.images[this.index];
          if (active?.complete && !active.naturalWidth) {
            const available = this.slides.findIndex((slide, i) => i !== this.index && this.ready(i));
            if (available >= 0) this.show(available);
          }
          this.sync();
        };
        image.addEventListener('load', refresh, { signal });
        image.addEventListener('error', refresh, { signal });
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.offscreen = !entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this.observer.observe(this);
      }
      this.show(0);
      this.sync();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.startupObserver?.disconnect();
      this.startupObserver = null;
      this.controller?.abort();
      this.controller = null;
      this.frame = null;
    }
    ready(index) {
      const image = this.images[index];
      return !image || (image.complete && image.naturalWidth > 0);
    }
    paused() {
      return this.userPaused || this.offscreen || this.editorPaused || document.hidden || Boolean(this.querySelector(':focus-visible'));
    }
    show(index) {
      this.index = index;
      this.nextIndex = null;
      this.phase = 'zoom';
      this.elapsed = 0;
      this.direction = 1;
      this.lastTime = null;
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', String(i === index));
      });
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-current', i === index);
        slide.style.opacity = i === index ? '1' : '0';
        slide.style.zIndex = '';
        slide.setAttribute('aria-hidden', String(i !== index));
        if (this.images[i]) this.images[i].style.transform = 'scale(1)';
      });
    }
    sync() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.lastTime = null;
      if (!this.paused() && this.isConnected) this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      this.frame = null;
      if (this.paused() || !this.isConnected) return;
      const delta = this.lastTime === null ? 0 : Math.min(time - this.lastTime, 100);
      this.lastTime = time;
      if (this.ready(this.index)) {
        this.elapsed += delta;
        if (this.phase === 'zoom') {
          const progress = Math.min(1, this.elapsed / this.zoomMs);
          if (this.images[this.index]) {
            const zoomProgress = this.direction === -1 ? 1 - progress : progress;
            const scale = this.respectMotion && this.motion.matches && !this.motionOverride ? 1 : 1 + (this.scale - 1) * zoomProgress;
            this.images[this.index].style.transform = `scale(${scale})`;
          }
          if (progress === 1) {
            if (this.slides.length === 1 || this.editorSelected) {
              if (this.slides.length === 1 && !this.editorSelected && this.dataset.repeatSingle !== 'true') return;
              // Reverse smoothly instead of stopping after three seconds or jumping to scale(1).
              this.direction *= -1;
              this.elapsed = 0;
              this.frame = requestAnimationFrame(nextTime => this.tick(nextTime));
              return;
            }
            const next = (this.index + 1) % this.slides.length;
            // Skip failed downloads, but wait for an in-progress next image.
            const nextImage = this.images[next];
            if (nextImage?.complete && !nextImage.naturalWidth) {
              const available = this.slides.findIndex((slide, i) => i !== this.index && this.ready(i));
              if (available >= 0) this.beginFade(available);
            } else if (this.ready(next)) {
              this.beginFade(next);
            }
          }
        } else {
          const duration = this.respectMotion && this.motion.matches && !this.motionOverride ? 0 : this.fadeMs;
          const progress = duration ? Math.min(1, this.elapsed / duration) : 1;
          // Incoming slide sits above the opaque outgoing slide: no dark dip mid-fade.
          this.slides[this.nextIndex].style.opacity = String(progress);
          if (progress === 1) {
            const next = this.nextIndex;
            this.slides[this.index].style.zIndex = '';
            this.slides[next].style.zIndex = '';
            this.show(next);
          }
        }
      }
      this.frame = requestAnimationFrame(nextTime => this.tick(nextTime));
    }
    beginFade(next) {
      this.phase = 'fade';
      this.elapsed = 0;
      this.nextIndex = next;
      this.slides[this.index].style.zIndex = '0';
      this.slides[next].style.zIndex = '1';
      this.slides[next].style.opacity = '0';
      this.slides[next].classList.add('is-current');
      if (this.images[next]) this.images[next].style.transform = 'scale(1)';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
